import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class ItineraryObsBlock extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }

    this.handleClickTracking = this.props.handleClickTracking.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
  }

  render() {
    const obsIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.obsIcon)
    const backgroundColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    return (
      <div className={`departure-info__essentials__detailitems__detailitem__infobox__obs foldable ${backgroundColor ? backgroundColor : ""}`}>
        <div
          className="departure-info__essentials__detailitems__detailitem__infobox__obs__header pointer"
          onClick={(e) => this.showHideContent(e, ".contentWrapper")}
        >
          {this.props.block.obsIconUpload ? <img className="icon" src={this.props.block.obsIconUpload} /> : obsIcon ? <Svg iconName={obsIcon} /> : ""}
          {this.props.block.obsHeadline}
        </div>
        <div className={"contentWrapper show-hide"}>
          <div className="info-text" dangerouslySetInnerHTML={{ __html: this.props.block.obsText }}></div>
        </div>
      </div>
    )
  }
}
